import { mapState, mapGetters } from 'vuex'
import branchTypes from '@/config/branchTypes'
import { PRODUCT_TYPE } from '@/config/product'
import { STOCK_CARD_TYPE } from '@/config/stockCard'

export default {
  computed: {
    ...mapState({
      selectSKU: state => state.model.selectSKU,
      branchType: state => state.branchStore.branchType,
      // OLD: coupon: state => state.cart.coupon,
      coupons: state => state.cart.coupons,
      cartDelivery: state => state.cart.delivery,
      cartSummaryData: state => state.cart.cartSummaryData,
      paymentId: state => state.paymentType.paymentId,
    }),

    ...mapGetters({
      bundles: 'model/getBundles',
      additionalProduct: 'model/getAdditionalProduct',
      appleCare: 'model/getAppleCare',
      accessoryBundles: 'model/getAccessoryBundles',
      isSoldOut: 'model/getSoldOut',
      memberFreebies: 'model/getMemberFreebies',

      cartItems: 'cart/cartItems',
      cartProductItem: 'cart/productItem',
      cartPriceSummary: 'cart/priceSummary',
      cartBundleItems: 'cart/bundleItems',
      cartDeliveryItems: 'cart/deliveryItems',
      cartDiscountOnTop: 'cart/discountOnTop',

      customer: 'user/getData',
    }),

    isDelivery() {
      return (
        this.cartDelivery === 'delivery' || this.cartDelivery === true
      )
    },

    isStore() {
      return this.cartDelivery === 'store'
    },

    isPDP() {
      return {
        pdp: this.$route.name === 'ProductDetail' || false,
      }
    },

    cartPayAtStore() {
      return {
        is_pay_at_store:
          (this.$route.query?.t &&
            this.$route.query?.t !== STOCK_CARD_TYPE.QR_ONLINE) ||
          false,
      }
    },
  },

  data() {
    return {
      formCheckSummary: {
        product_id: '',
        bundle_products: [],
        coupon_codes: [],
        delivery: false,
        is_delivery: false,
        is_pay_at_store: false,
      },
      branchTypes: branchTypes,
    }
  },

  methods: {
    async checkSummary() {
      await this.$store.dispatch('user/fetchData')

      this.prepareCheckSummary()

      await this.$store.dispatch(
        'cart/cartSummary',
        this.formCheckSummary,
      )

      // Reset bundle items before adding new ones
      this.$store.dispatch('bundle/reset')

      const hasDelivery = this.cartSummaryData?.final_bundle_products?.some(
        item => item.detail?.type === PRODUCT_TYPE.DELIVERY,
      )

      if (!hasDelivery) {
        // Reset delivery items if no delivery type is found
        this.$store.dispatch('bundle/resetDelivery')
      }

      // Replace the bundle products in the cart with the final bundle products
      if (this.cartSummaryData?.final_bundle_products.length > 0) {
        // Add each final bundle product to the cart
        this.cartSummaryData?.final_bundle_products.forEach(item => {
          // Check if the item is a bundle product
          if (item.detail?.type !== PRODUCT_TYPE.DELIVERY) {
            this.handleAutoAddToCart('add', item.detail)
          }
        })
      }

      this.$forceUpdate()
    },

    prepareCheckSummary() {
      // OLD:
      // let coupon_code = undefined
      // coupon_code =
      //   this.coupon.code && !this.coupon.isError
      //     ? this.coupon.code
      //     : undefined
      const coupon_codes = this.coupons?.map(c => c.code) ?? []

      let payment_type_id = this.paymentId ?? undefined

      let bundleSelect = []

      this.bundles?.forEach(i => {
        let has = false
        if (this.cartBundleItems.find(b => b.sku === i.sku)) {
          has = true
        }
        if (has) {
          bundleSelect.push(
            this.cartBundleItems.filter(b => b.sku === i.sku)?.[0],
          )
        }
      })

      let additionProductSelect = []
      this.additionalProduct?.forEach(i => {
        let has = false
        if (this.cartBundleItems.find(b => b?.sku === i?.sku)) {
          has = true
        }
        if (has) {
          additionProductSelect.push(
            this.cartBundleItems.filter(b => b?.sku === i?.sku)?.[0],
          )
        }
      })

      let appleCareSelect = []
      let has = false
      if (
        this.cartBundleItems.find(b => b?.sku === this.appleCare?.sku)
      ) {
        has = true
      }

      if (has) {
        appleCareSelect.push(
          this.cartBundleItems.filter(
            b => b?.sku === this.appleCare?.sku,
          )?.[0],
        )
      }

      let accessoryBundlesSelect = []
      this.accessoryBundles?.forEach(i => {
        let has = false
        if (this.cartBundleItems.find(b => b?.sku === i?.sku)) {
          has = true
        }
        if (has) {
          accessoryBundlesSelect.push(
            this.cartBundleItems.filter(b => b?.sku === i?.sku)?.[0],
          )
        }
      })

      this.formCheckSummary.product_id = this.cartProductItem?.id
      this.formCheckSummary.bundle_products = [
        ...bundleSelect,
        ...additionProductSelect,
        ...appleCareSelect,
        ...accessoryBundlesSelect,
        ...this.cartDeliveryItems,
      ]

      // OLD: this.formCheckSummary.coupon_code = coupon_code
      this.formCheckSummary.coupon_codes =
        coupon_codes.length > 0 ? coupon_codes : undefined
      this.formCheckSummary.payment_type_id = payment_type_id
      this.formCheckSummary.delivery =
        !this.isStore && !this.isDelivery ? undefined : !this.isStore
      this.formCheckSummary.is_delivery = !this.isStore

      this.formCheckSummary = {
        ...this.formCheckSummary,
        ...this.cartPayAtStore,
        ...this.isPDP,
      }

      // Set customer data if available
      if (this.customer.member_id) {
        this.formCheckSummary = {
          ...this.formCheckSummary,
          member_id: this.customer.member_id || null,
        }
      }
    },

    handleAutoAddToCart(key, item) {
      switch (key) {
        case 'remove':
          this.$store.dispatch('bundle/remove', item)
          break

        default:
          this.$store.dispatch('bundle/add', item)
          break
      }
    },
  },
}
